import React from 'react';
import RegionCard from './RegionCard';
import './RegionPage.style.css'; 

const RegionPage = () => {
  return <div>
    <RegionCard />
  </div>;
};

export default RegionPage;
